import { useContext } from "react"
import { Context } from "./Context"

export const useRatingAccount = () => {
  return useContext(Context)
}
